import { lazy } from 'react';

export const StatisticsFeature = lazy(() => import('./pages/StatisticsFeature'));
